import PropTypes from 'prop-types';
import React from 'react';
import { isElement } from 'react-is';
import { ScrollSyncPane } from 'react-scroll-sync';
import { FrameContextConsumer } from 'react-frame-component';
/**
 * We need to create a lightweight component here so that we can access the
 * context within the Frame. This allows us to attach the ScrollSyncPane to the
 * body.
 */

import { jsx as ___EmotionJSX } from "@emotion/core";

class PreviewContent extends React.Component {
  render() {
    const {
      previewComponent,
      previewProps
    } = this.props;
    return ___EmotionJSX(FrameContextConsumer, null, context => ___EmotionJSX(ScrollSyncPane, {
      attachTo: context.document.scrollingElement
    }, isElement(previewComponent) ? /*#__PURE__*/React.cloneElement(previewComponent, previewProps) : /*#__PURE__*/React.createElement(previewComponent, previewProps)));
  }

}

PreviewContent.propTypes = {
  previewComponent: PropTypes.func.isRequired,
  previewProps: PropTypes.object
};
export default PreviewContent;